// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../../types/selectors';
import { type BoomStepState } from '../../reducers/boom';
import { selectBoomOrderedSteps } from '../../selectors/steps.selector';
import { selectBoomUserProgressEntityStatus } from '../../selectors/user/userPrimary.selector';
import { selectBoomUserProgressAllIsCompleted } from '../../selectors/user.selector';
import { type BoomStepStatus } from '../../types/steps';

type BoomStepperPropsType = {
  steps: BoomStepState[];
  currenStepStatus: BoomStepStatus;
  isCompleted: boolean;
};

const selectBoomStepperProps: Selector<BoomStepperPropsType> = createSelector(
  [selectBoomOrderedSteps, selectBoomUserProgressEntityStatus, selectBoomUserProgressAllIsCompleted],
  (steps, currenStepStatus, isCompleted) => ({
    steps,
    currenStepStatus,
    isCompleted,
  }),
);

export default selectBoomStepperProps;
